export const setCenter = (center) => ({
  type: 'SET_CENTER',
  payload: center,
});

export const setZoom = (zoom) => ({
  type: 'SET_ZOOM',
  payload: zoom,
});
